import * as yup from 'yup';
import { treasuryPersonalEmailFormFields } from '../../fields/formFields/treasuryPersonalEmail';

export const treasuryPersonalEmailSchema = yup.object({
  [treasuryPersonalEmailFormFields.personalEmail]: yup
    .string()
    .email('Enter a valid email')
    .max(255, 'Email must be at most 255 characters')
    .required('Personal email is required')
    .trim(),
});
